import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f9dfcad"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "carousel-item" }
const _hoisted_2 = { class: "card-token-header" }
const _hoisted_3 = { class: "flex align-items-baseline" }
const _hoisted_4 = { class: "caption uppercase mr-s1" }
const _hoisted_5 = { class: "h3 text-gradient-light" }
const _hoisted_6 = { class: "card-token-content gutter-y-s1" }
const _hoisted_7 = { class: "flex align-items-center gutter-x-s2" }
const _hoisted_8 = { class: "caption" }
const _hoisted_9 = { class: "flex align-items-center gutter-x-s2" }
const _hoisted_10 = { class: "caption" }

import TokenIcon from '@/components/token/TokenIcon.vue';
import { SingleSideToken } from '@/views/pages/liquidity/single-side/models/single-side-token';
import { useI18n } from 'vue-i18n';
import { format } from '@/utils/format';
import { computed } from 'vue';
import BigNumber from 'bignumber.js';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleSideCarouselItem',
  props: {
    token: null
  },
  setup(__props: any) {

const props = __props as {
  token: SingleSideToken;
}



const { t } = useI18n();
const router = useRouter();

const printApr = computed(() => {
  if (props.token.apr.toNumber() < 1) {
    return `<1%`;
  }
  return props.token.apr.toNumber() > 10000 ? `>10 000%` : `${format(props.token.apr.toFixed(2))}%`;
});

const onClickToken = () => router.push(`/single-side/${props.token.id}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "card-token",
      role: "button",
      onClick: onClickToken
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TokenIcon, {
          "icon-src": __props.token.portfolioToken.tokenIconUrl,
          symbol: __props.token.portfolioToken.symbol,
          full: "",
          size: "32",
          class: "h3 text-bold"
        }, null, 8, ["icon-src", "symbol"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('apr')), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(printApr)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('singleSide.noFeeLimit.caption')) + ":", 1),
          _createElementVNode("div", null, _toDisplayString(_unref(format)(__props.token.noFeeLimit.toFixed(2, _unref(BigNumber).ROUND_DOWN))), 1),
          _createVNode(TokenIcon, {
            "icon-src": __props.token.portfolioToken.tokenIconUrl,
            symbol: __props.token.portfolioToken.symbol,
            size: "16"
          }, null, 8, ["icon-src", "symbol"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('singleSide.portfolio.caption')) + ":", 1),
          _createElementVNode("div", null, _toDisplayString(__props.token.portfolio.name), 1)
        ])
      ])
    ])
  ]))
}
}

})